module.exports = __webpack_public_path__ + "img/TSOTO.961cea5d.png";